import { gql } from '@apollo/client';

export const FETCH_CANDIDATE_PUBLIC_PROFILE = gql`
  query fetchCandidatePublicProfile($input: FetchCandidatePublicProfileInput!) {
    fetchCandidatePublicProfile(input: $input) {
      candidateProfileId
      candidateDetails {
        candidateProfileId
        candidateFirstName
        candidateLastName
        candidateEmail
        candidatePhoto
        vanityLinkText
      }
      referencerDetails {
        candidateReferencerRelationId
        workRelationship
        overlapStartDate
        overlapEndDate
        companyName
        candidateRole
        publicSummary
        referencerTitle
      }
      candidateStrengths {
        candidateProfileId
        count
        attribute {
          attributeId
          attributeName
          subtitle
          isStrength
        }
      }
      behaviorProfile {
        candidateProfileId
        firstAnswerOptionValue
        secondAnswerOptionValue
        firstAnswerOption {
          answerOptionId
          optionName
          subtitle
        }
        secondAnswerOption {
          answerOptionId
          optionName
          subtitle
        }
      }
    }
  }
`;

export const CREATE_CANDIDATE_SHARE_REQUEST = gql`
  mutation createCandidateShareRequest($input: CreateCandidateShareRequestInput!) {
    createCandidateShareRequest(input: $input) {
      candidateShareId
      candidateShareRequestId
    }
  }
`;
